import { Button, Form, Input, Tag } from 'antd';
import React, { ChangeEventHandler } from 'react';
import styled from 'styled-components';
import { UserStore } from '../../stores/userStore';
import { inject, observer } from 'mobx-react';

interface UserNavProps {
    userStore?: UserStore;
}

const DefaultPageWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 0 40px;
    margin-top: 80px;
    max-width: 1800px;
`;

@inject('userStore')
@observer
export class UpdatePassword extends React.Component<UserNavProps> {
    state = {
        visible: false,
        focus: true
    };

    labelVisibleChange = () => {
        this.setState({ visible: true });
    };
    labelInvisibleChange = () => {
        this.setState({ visible: false });
    };

    getNewPass: ChangeEventHandler<HTMLInputElement> = event => {
        const { userStore } = this.props;
        userStore!.newPassword = event.target.value;
        this.verificarInvalidPassword();
    };
    validatePassConfirm: ChangeEventHandler<HTMLInputElement> = event => {
        const { userStore } = this.props;
        userStore!.confirmPassword = event.target.value;
        this.verificarInvalidPassword();
    };

    cambiarContraseña = async () => {
        const { userStore } = this.props;
        if (userStore!.newPassword === userStore!.confirmPassword) {
            await userStore!.actualizarContraseña();
        }
    };

    verificarInvalidPassword = () => {
        const { userStore } = this.props;
        if (userStore!.newPassword !== userStore!.confirmPassword) {
            this.labelVisibleChange();
        } else {
            this.labelInvisibleChange();
        }
    };

    onfocus = () => {
        this.setState({ focus: false });
    };

    onBlur = () => {
        this.setState({ focus: true });
    };

    render() {
        const styleError = { color: 'red', display: !this.state.visible ? 'none' : '' };
        const styleInputConfirm = {
            border: this.state.visible && this.state.focus ? '1px solid red' : ''
        };
        const stylePrimary = {
            backgroundColor:'#a8123e', borderColor:'#a8123e'
        };
        return (
            <DefaultPageWrapper>
                <Form style={{ width: '400px' }} layout="horizontal" className="update-form">
                    <Form.Item label="Nueva Contraseña">
                        <Input.Password onChange={this.getNewPass} />
                    </Form.Item>
                    <Form.Item label="Vuelve a escribir tu nueva contraseña">
                        <Input.Password
                            onChange={this.validatePassConfirm}
                            onFocus={this.onfocus}
                            onBlur={this.onBlur}
                            onMouseEnter={this.onfocus}
                            style={styleInputConfirm}
                        />
                        <div style={styleError}>Las contraseñas no coinciden</div>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={this.cambiarContraseña} style={stylePrimary}>
                            Actualizar
                        </Button>
                    </Form.Item>
                </Form>
            </DefaultPageWrapper>
        );
    }
}
export default UpdatePassword;
